__turbopack_context__.v({
  "infoTooltip": "tooltip-module-sass-module__TY281G__infoTooltip",
});
